import React from 'react'
import { shallow } from 'enzyme'
import NewAdminsList from '../NewAdminsList'
import AdminAutocomplete from '../AdminAutocomplete'

describe('<NewAdminsList />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      selectedAdmins: [
        { name: 'test admin 1', rid: 1 },
        { name: 'test admin 2', rid: 2 }
      ],
      onAdminSelect: () => {},
      onAdminRemove: () => {}
    }
    wrapper = shallow(<NewAdminsList {...props} />)
  })
  it('should return one <AdminAutocomplete /> for each selectedAdmin, plus one extra', () => {
    expect(wrapper.find(AdminAutocomplete)).toHaveLength(props.selectedAdmins.length + 1)
  })
})
